import { useDataset } from '@infinex/user';

export function useGasBalance() {
  const { data: { ledgerBalances } = {}, status } =
    useDataset('ledgerBalances');

  const balance = Number(
    ledgerBalances?.find((b) => b.category === 'gas')?.balance ?? 0
  );
  const clampedBalance = Math.max(0, balance);

  return {
    status,
    data: clampedBalance,
  };
}
